import React from "react";
import moment from "moment";
import CButton from "../../components/UI/CButton";

import "./style.scss";

function getParticipationTypeLabel(array, type, $locale) {
    if (!array) {
        return $locale.get(`participationType.${type}`);
    }

    const option = array.find(({value}) => value === type);

    return $locale.getProperty(option, 'label');
}

export const ParticipationTypeSelectBlock = ({
    $locale,
    eventName,
    timeStart,
    hideSubtitle,
    subtitle = '',
    participationTypeLabels,
    hideInfoBlock,
    onSelect,
}) => {
    const Heading = hideInfoBlock ? 'h1' : 'h2';

    const eventTimeStart = moment.unix(timeStart).format('LLL') + ' (UTC' + moment.unix(timeStart).format('Z') + ')';

    return (
        <div className={`authentication-form paticipation-select ${hideInfoBlock ? 'paticipation-select--sm' : ''}`}>
            <Heading>
                {
                    hideInfoBlock
                    ? eventName
                    : $locale.get('broadcast.auth.participation-select.login-title')
                }
            </Heading>
            {
                (hideInfoBlock || !hideSubtitle) &&
                <div className="email-request-header">
                    {
                        hideInfoBlock &&
                        <p>{$locale.get('ticketAuth.timeStart', {datetime: eventTimeStart})}</p>
                    }
                    {
                        !hideSubtitle &&
                        <p>{subtitle || $locale.get('broadcast.auth.participation-select.login-subtitle')}</p>
                    }
                </div>
            }
            <div className="paticipation-select__buttons">
                <CButton
                    size="md-x2"
                    theme="accent"
                    label={getParticipationTypeLabel(participationTypeLabels, 'online', $locale)}
                    onClick={() => onSelect('online')}
                />
                {$locale.get('broadcast.or')}
                <CButton
                    size="md-x2"
                    theme="accent"
                    label={getParticipationTypeLabel(participationTypeLabels, 'offline', $locale)}
                    onClick={() => onSelect('offline')}
                />
            </div>
        </div>
    );
};
